import { useRouter } from 'next/router';
import Browse from '~/components/browse/Browse';
import { getDeals, extractBrowse } from '~/lib/browse/fetch';
import { SWRConfig } from 'swr';
import { DEALATTRIBUTE_PERSONAL_URL } from '~/lib/attributes/constants';
import useAttributes from '~/lib/attributes/hook';
import { fetchJson } from '~/lib/fetch';
import { BrowseSeo } from '~/components/seo';
import { useBeacon } from '~/lib/script';

export async function getStaticProps({ params }) {
  const { slug } = params;
  const attributes = await fetchJson(DEALATTRIBUTE_PERSONAL_URL);
  const initialFilters = extractBrowse({ slug, dealAttributes: attributes });

  // if page is greater than N we will load the first N pages and then load the rest in the client
  const deals = await getDeals(initialFilters);

  return {
    props: {
      fallbackData: [deals],
      isCollectionBrowsePage: true, // used to clear search (initially) if not on this page
      fallback: {
        [DEALATTRIBUTE_PERSONAL_URL]: attributes,
      },
    },
    revalidate: 240,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export default function BrowsePage({ fallback = {}, fallbackData }) {
  const router = useRouter();
  useBeacon();
  const { data: dealAttributes } = useAttributes({
    fallbackData: fallback[DEALATTRIBUTE_PERSONAL_URL],
  });
  const initialFilters = extractBrowse({
    slug: router.query.slug,
    dealAttributes,
    query: router.query,
  });
  const { attributes = {} } = initialFilters;

  const isSearching = !!initialFilters.query;

  const showBreadcrumbs = attributes.category && !isSearching;

  return (
    <SWRConfig
      value={{
        fallback,
      }}
    >
      <BrowseSeo
        group={attributes.group}
        category={attributes.category}
        subcategory={attributes.subcategory}
      />
      <Browse
        initialFilters={initialFilters}
        fallbackData={fallbackData}
        showTitle={true}
        showBreadcrumbs={showBreadcrumbs}
      />
    </SWRConfig>
  );
}
